import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger} from "../LibrariesImport";

export default class Search {
	static init() {
		this.initSearchButton();
		this.initSearchSelects();
	}

	static initSearchButton() {
		const fixedSearchButton = document.querySelector(".fixed-search-button");
		const mobileSearchButton = document.querySelector(".mobile-search-button");
		const searchModal = document.querySelector(".search-modal");
		const searchInput = document.querySelector("#modalSearchInput");

		fixedSearchButton.addEventListener("click", () => {
			if (fixedSearchButton.classList.contains("active")) {
				fixedSearchButton.classList.remove("active")
				searchModal.classList.remove("active");
			} else {
				fixedSearchButton.classList.add("active")
				searchModal.classList.add("active");
				searchInput.focus();
			}
		});

		mobileSearchButton.addEventListener("click", () => {
			if (mobileSearchButton.classList.contains("active")) {
				mobileSearchButton.classList.remove("active")
				searchModal.classList.remove("active");
			} else {
				mobileSearchButton.classList.add("active")
				searchModal.classList.add("active");
				if (!GlobalVariables.isMobile) {
					searchInput.focus();
				}
			}
		});

		searchModal.addEventListener('click', function (e) {
			if (e.target !== this) {
				return;
			}
			searchModal.classList.remove('active');
			fixedSearchButton.classList.remove("active");
			mobileSearchButton.classList.remove("active");
		});

		ScrollTrigger.matchMedia({
			"(min-width: 768px)": () => {
				ScrollTrigger.create({
					start: () => window.innerHeight * 0.05 + " top",
					onEnter: () => {
						fixedSearchButton.classList.add('show');
					},
					onLeaveBack: () => {
						fixedSearchButton.classList.remove('show');
					}
				});
			}
		});
	}

	static initSearchSelects() {
		document.querySelectorAll(".search-modal .criteria select").forEach(select => {
			select.addEventListener("change", evt => {
				if (evt.target.value) {
					window.location.href = evt.target.value;
				}
			});
		});
	}
}
